module.exports = __webpack_public_path__ + "h5/img/ball-up.d4259809.png";